import axiosInstance from "../lib/axiosInstance";

class ordersModel {
  constructor() {
    this.base_url = "/orders";
    this.base_url2 = "/reports/order";
    this.base_url3 = "/vendor_orders";
    this.base_url3 = "/order_item";
  }
  async list(query = []) {
    return (
      await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)
    ).data;
  }
  async create(data = []) {
    return await axiosInstance.post(this.base_url, data);
  }

  async orderRemark(id,data = []) {
    return await axiosInstance.post(`${this.base_url}/${id}/remarks`, data);
  }

  async update(id, data = []) {
    return await axiosInstance.post(`${this.base_url}/${id}?_method=PUT`, data);
  }
  async destroy(id, data = []) {
    return await axiosInstance.delete(`${this.base_url}/${id}`, data);
  }
  async show(id) {
    return (await axiosInstance.get(`${this.base_url}/${id}`)).data;
  }
  async ExportOrder(data = []) {
    return await axiosInstance.post(`${this.base_url2}`, data);
  }
  async pack(id) {
    return await axiosInstance.post(`${this.base_url}/${id}/pack`);
  }

  async itemUpdate(id, data = []) {
    return await axiosInstance.post(`/order_item/${id}?_method=PUT`, data);
  }

  async cancel(id) {
    return await axiosInstance.post(`${this.base_url}/${id}/cancel`);
  }
  async admincancel(id) {
    return await axiosInstance.post(`${this.base_url}/${id}/cancelnew`);
  }

  async replace(id,data=[]) {
    return await axiosInstance.post(`${this.base_url}/${id}/replacement`,data);
  }
  async return(id,data=[]) {
    return await axiosInstance.post(`${this.base_url}/${id}/return`,data);
  }

  async updateSubOrderId(id, data = []) {
    return await axiosInstance.post(
      `${this.base_url3}/${id}?_method=PUT`,
      data
    );
  }

   async updateOrderStatus(id, data = []) {
    return await axiosInstance.post(
      `${this.base_url}/${id}/items/status`,
      data
    );
  }
}

export default new ordersModel();
